import { gql } from '@/__generated__';

export const FORMIE_FORM_QUERY = gql(`
  query formieForm($id: [QueryArgument], $uid: [String]) {
    formieForm(id: $id, uid: $uid) {
      __typename
      id
      uid
      handle
      submissionMutationName
      slug
      rows {
        ...formieRow
      }
      captchas {
        ...formieCaptcha
      }
      settings {
        submitActionMessageHtml
        errorMessageHtml
      }
      paymentFields: formFields {
        ...fieldPayment
      }
    }
  }
`);
